import FormContentCreateOrEditCreator from './FormContentCreateOrEditCreator';

export default FormContentCreateOrEditCreator;

export type TProps = {
  requireReferralCode? : boolean;
  readonly?: boolean;
  fieldNames: {
    referralCode: string;
    username: string;
    gender: string;
    links: string;
    type: string;
    coinsAmount: string;
    paymentInfo: {
      phoneNumberOwnerName: string;
      phoneNumber: string;
      method: string;
      email: string;
      iban: string;
      bic: string;
    }
  }
};
